import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core'
import { CdkConnectedOverlay, CdkOverlayOrigin, ConnectedPosition } from '@angular/cdk/overlay'

@Component({
  selector: 'ranking-tag',
  imports: [CdkOverlayOrigin, CdkConnectedOverlay],
  templateUrl: './ranking-tag.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RankingTag {
  ranking = input.required<string>()
  message = input<string>('')
  isOpen = signal(false)

  positions: ConnectedPosition[] = [
    {
      originX: 'center',
      originY: 'top',
      overlayX: 'center',
      overlayY: 'bottom',
      offsetY: -8
    }
  ]
}
